import { useQuery } from '@tanstack/react-query';
import { httpClient } from '../api/http';
import { useState } from 'react';
import { TRANSFER_PROVIDER_ACTIONS } from '../api/enums';

const useProcessor = () => {
  const [isLoading, setIsLoading] = useState({
    toggleProcessorStatus: false,
    assignBanksToProvider: false,
    updateMinimumBalanceThreshold: false,
  });
  const {
    data: Processors,
    isLoading: isLoadingProcessors,
    refetch: refetchProcessors,
    isRefetching: isRefetchingProcessors,
    isError: isErrorProcessors,
  } = useQuery({
    queryKey: ['processors'],
    queryFn: () => httpClient.get(`/admin/site-configuration/payment-processor/view`).then((res) => res.data.data),
  });

  const {
    data: Banks,
    isLoading: isLoadingBanks,
    refetch: refecthBanks,
    isRefetching: isRefetchingBanks,
    isError: isErrorBanks,
  } = useQuery({
    queryKey: ['banks'],
    queryFn: () =>
      httpClient.get(`/admin/site-configuration/payment-processor/bank-list`).then((res) => res.data.data.banks),
  });

  const toggleProcessorStatus = async (provider: string, status: boolean, callback?: () => void) => {
    try {
      setIsLoading((prev: any) => ({ ...prev, toggleProcessorStatus: true }));
      const response = await httpClient.post(`/admin/site-configuration/payment-processor/actions`, {
        provider,
        action: status ? TRANSFER_PROVIDER_ACTIONS.ENABLE_PROVIDER : TRANSFER_PROVIDER_ACTIONS.DISABLE_PROVIDER,
      });

      await refetchProcessors();
      callback && callback();

      return response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      setIsLoading((prev: any) => ({ ...prev, toggleProcessorStatus: false }));
    }
  };

  const assignBanksToProvider = async (provider: string, bankCodes: string[], callback?: () => void) => {
    try {
      setIsLoading((prev: any) => ({ ...prev, assignBanksToProvider: true }));
      const response = await httpClient.post(`/admin/site-configuration/payment-processor/actions`, {
        provider,
        bankCodes,
        action: TRANSFER_PROVIDER_ACTIONS.ASSIGN_BANKS_TO_PROVIDER,
      });

      await refetchProcessors();
      callback && callback();
      return response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      setIsLoading((prev: any) => ({ ...prev, assignBanksToProvider: false }));
    }
  };

  const updateMinimumBalanceThreshold = async (
    provider: string,
    minimumBalanceThreshold: number,
    callback?: () => void,
  ) => {
    try {
      setIsLoading((prev: any) => ({ ...prev, updateMinimumBalanceThreshold: true }));
      const response = await httpClient.post(`/admin/site-configuration/payment-processor/actions`, {
        provider,
        minimumBalanceThreshold,
        action: TRANSFER_PROVIDER_ACTIONS.SET_MINIMUM_BALANCE_THRESHOLD,
      });

      await refetchProcessors();
      callback && callback();
      return response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      setIsLoading((prev: any) => ({ ...prev, updateMinimumBalanceThreshold: false }));
    }
  };

  return {
    isLoading,
    Processors,
    isLoadingProcessors,
    isRefetchingProcessors,
    isErrorProcessors,
    refetchProcessors,
    toggleProcessorStatus,
    assignBanksToProvider,
    updateMinimumBalanceThreshold,
    Banks,
    isLoadingBanks,
    refecthBanks,
    isRefetchingBanks,
    isErrorBanks,
  };
};

export default useProcessor;
